export default {
  viewFullscreen: 'View fullscreen',
  exitFullscreen: 'Exit fullscreen',
  removeSelectedPoint: 'Remove selected point',
  removeSelectedPoints: 'Remove selected points',
  showPlansOnMap: 'Show plans on map',
  hidePlansOnMap: 'Hide plans on map',
  chooseThisPointAs_: 'Choose this point as {title}',
  coordinates: 'Coordinates',
  submit_: 'Submit {title}',
  extractingAddress: 'Extracting address ...',
  newDestination: 'New destination',
  theSelectedCoordinatesAreWithinThe_:
    'The selected coordinates are within the',
  position: 'Position'
}
